<template>
	<div class="auth-page">
		<div class="auth-card">
			<div class="auth-logo">
				<img v-if="name.startsWith('http')" :src="name" alt="logo" />
				<span v-else class="logo-fallback">{{ name }}</span>
			</div>
			<div class="auth-badge"><i class="fas fa-user-shield"></i></div>
			<h1 class="auth-title">Connexion administrateur</h1>
			<p class="auth-subtitle">Connectez-vous au compte d'un client</p>

			<b-form class="auth-form" @submit="onSubmit">
				<div class="auth-field">
					<label for="user">Votre identifiant</label>
					<b-form-input
						id="user"
						class="auth-input"
						type="text"
						v-model="form.user"
						required
						autofocus
						placeholder="Identifiant"></b-form-input>
				</div>
				<div class="auth-field">
					<label for="pwd">Votre mot de passe</label>
					<b-input-group>
						<b-form-input
							id="pwd"
							class="auth-input"
							:type="showPassword ? 'text' : 'password'"
							v-model="form.pwd"
							required
							placeholder="Mot de passe"></b-form-input>
						<template #append>
							<b-button
								variant="outline-secondary"
								tabindex="-1"
								@click="showPassword = !showPassword">
								<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
							</b-button>
						</template>
					</b-input-group>
				</div>
				<div class="auth-row">
					<div class="auth-field">
						<label for="client">Client</label>
						<b-form-input
							id="client"
							class="auth-input"
							type="text"
							v-model="form.client"
							placeholder="Client"></b-form-input>
					</div>
					<div class="auth-field">
						<label for="user_client">Utilisateur</label>
						<b-form-input
							id="user_client"
							class="auth-input"
							type="text"
							v-model="form.user_client"
							placeholder="Client User"></b-form-input>
					</div>
				</div>

				<b-button type="submit" class="auth-submit" variant="primary">Valider</b-button>
			</b-form>

			<b-alert class="auth-alert" v-if="error" show variant="danger">{{ errorMsg }}</b-alert>

			<div class="auth-links">
				<a href="/password_reset">Mot de passe oublié ?</a>
			</div>
		</div>
	</div>
</template>

<script>
	import login from "../services/login.js";
	import users from "../services/users.js";

	export default {
		nam: "login_admin",
		data() {
			return {
				form: {
					user: "",
					pwd: "",
					client: "",
					user_client: ""
				},
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || "Smartmydata",
				saas_back: process.env.VUE_APP_SAAS_BACK,
				showPassword: false
			};
		},
		methods: {
			login_google()
			{
				login.login_google()
			},
			onSubmit(evt) {
				evt.preventDefault();
				login
					.auth(this.form.user, this.form.pwd, this.form.client, this.form.user_client)
					.then(async (res) => {
						let jwt = res.data.jwt;
						this.$store.commit("setJwt", jwt);

						var response = await users.getSelf(true);
						this.$store.commit("setUser", response.user);

						if (this.form.client || this.form.user_client)
							this.$store.commit("setAdminSession", true);

						this.$emit("loginSuccess");
						this.$router.push({ name: "main" });
					})
					.catch(() => {
						this.error = true;
						this.errorMsg =
							"L'email et/ou le mot de passe et/ou le client sont invalides";
					});
			},
		},
	};
</script>

